import moment from 'moment';

import {
  dateFormat
} from '@/constants';

export default (date, toFormat, fromFormat) => {
  let format = fromFormat ? fromFormat : dateFormat;
  return moment(date, format).format(toFormat);
};